function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Light_switch"
}, /*#__PURE__*/React.createElement("title", null, "VF_light_switch_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 233.9c15.7 0 28.4-8.8 28.4-28.4s-12.7-28.3-28.4-28.3-28.3 8.8-28.3 28.3 12.7 28.4 28.3 28.4zm0-42.6c12.6 0 14.2 7.6 14.2 14.2s-1.6 14.2-14.2 14.2-14.2-7.6-14.2-14.2c.1-6.6 1.7-14.2 14.2-14.2zM134.6 49.6h14.2v56.7h-14.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.6 0v283.5h184.2V0H49.6zm155.9 255.1H77.9V148.8h127.6v106.3zm0-120.5H78V28.3h127.6v106.3z"
}))));